export const POSITION_INCREMENT = 200;
export const STEP_WIDTH = 400;
export const STEP_HEIGHT = 110;
export const CONDITION_WIDTH = 80;
export const TASK_MIN_WIDTH = 320;
export const TASK_MIN_HEIGHT = 320;
export const MAX_CONDITION = 6;
